import React, { Component, ReactNode } from 'react'
import { observer, inject } from 'mobx-react';
import { store } from 'Store/store.index';
import autoBindReact from 'auto-bind/react';
import {
    PaperCheckDialog,
    PaperCheckHistoryDialog,
    PaperCheckResultDialog,
    PaperCheckDiscountNotice
} from 'Components/dialogs/index';
import wrapDialog from '@/routes/wrapperDialog';


import { DialogContainer, DLG_TARGETS } from '../viewer/EditorDialogsContainer';

import { CHECK_TYPE, PCHECKER_JAEGERDATA_MAP, CHECK_ENGINE_TYPE } from 'Components/PaperCheck/contant';

import {
    PAPER_CHECK_HISTORY,
    PAPER_CHECK_NEW,
    PAPER_CHECK_PUBLISHED,
    PAPER_CHECK_NEW_HOME,
    PAPER_CHECK_PUBLISHED_HOME
} from 'Components/viewer/ui/constants/paper-check'
import { DiscountDetail, PriceDetail, PaperCheckItemInstance, StringOrNumber } from './CustomTypeAndInterface';
import { getDiscountNoticeDisplayedStorageKey, isInDiscountDateUtil } from './utils';
import { storageGetItem, storageSetItem } from '@/utils/utils';

interface CheckDialogShowInfo {
    isAutoShowFileSelect?: boolean,
    checkType?: string,
    [key: string]: any
}

interface Props {
    containerCallbacks: any
}
interface State {
    messageConfig: any,
    checkDialogShowInfo: CheckDialogShowInfo,
    resultItem: PaperCheckItemInstance,
    discountDetail?: DiscountDetail,
    isShowPaperCheckDiscountNotice: boolean
}
@inject('paperCheckStore')
@observer
class PaperCheckContainer extends Component<Props, State> {
    state: State = {
        messageConfig: {},
        checkDialogShowInfo: {
            isAutoShowFileSelect: false,
            checkType: CHECK_TYPE.New
        },
        resultItem: null,
        discountDetail: null,
        isShowPaperCheckDiscountNotice: false
    };
    constructor(props: Props) {
        super(props)
        autoBindReact(this);
    }

    componentDidMount(): void {
        const actions = {
            [PAPER_CHECK_HISTORY]: () => {
                if (!store.appStore.checkAppSignIn()) {
                    return;
                }
                store.paperCheckStore.setShowPaperCheckHistoryDialog(true);
            },
            [PAPER_CHECK_NEW]: () => {
                this.showPaperCheckDialog({ checkTypeName: PAPER_CHECK_NEW, from: 'paper-check' });
            },
            [PAPER_CHECK_PUBLISHED]: () => {
                this.showPaperCheckDialog({ checkTypeName: PAPER_CHECK_PUBLISHED, from: 'paper-check' });
            },
            [PAPER_CHECK_NEW_HOME]: () => {
                this.showPaperCheckDialog({ checkTypeName: PAPER_CHECK_NEW, from: 'home' });
            },
            [PAPER_CHECK_PUBLISHED_HOME]: () => {
                this.showPaperCheckDialog({ checkTypeName: PAPER_CHECK_PUBLISHED, from: 'home' });
            }
        };
        const { setupViewerActionCallback } = this.props.containerCallbacks;
        Object.keys(actions).map(name => {
            setupViewerActionCallback(name, actions[name]);
        })
        store.paperCheckStore.setShowPaperCheckNoticeInfoDialog(this.showPaperCheckNoticeInfoDialog);
        store.paperCheckStore.setShowPaperCheckMessageDialog(this.showPaperCheckMessageDialog);
        store.paperCheckStore.setShowPaperCheckResultNoticeMessage(this.showPaperCheckResultNoticeMessage);
        store.paperCheckStore.setShowPaperCheckResultDialogMethod(this.showPaperCheckResultDialog);
        store.paperCheckStore.setShowPaperCheckDialogMethod(this.showPaperCheckDialog);

        this.showPaperCheckDiscountNotice();
    }

    showPaperCheckDiscountNotice() {
        store.paperCheckStore.getPaperCheckEngineInfo().then((engineInfo: any) => {
            if (engineInfo && engineInfo[CHECK_ENGINE_TYPE.WangFang]) {
                let price_detail = engineInfo[CHECK_ENGINE_TYPE.WangFang].price_detail as PriceDetail;
                if (isInDiscountDateUtil(price_detail, CHECK_TYPE.New)) {
                    let discount = price_detail[`${CHECK_TYPE.New}_discount`] as DiscountDetail;
                    let storageKey = getDiscountNoticeDisplayedStorageKey(discount);
                    let isShow = this.getLocalStorageValue(storageKey)
                    if (isShow) {
                        this.setState({
                            isShowPaperCheckDiscountNotice: true,
                            discountDetail: discount
                        })
                    }
                }
            }
        }, err => {
        });
    }

    getLocalStorageValue(key: String) {
        let isShow = true;
        let storageValue = storageGetItem(localStorage, key);
        if (storageValue) {
            try {
                isShow = !JSON.parse(storageValue);
            } catch (error) {
            }
        }
        return isShow;
    }

    onCloseDialog() {
        this.setState({
            messageConfig: {
                target: ''
            }
        })
    }

    showPaperCheckNoticeInfoDialog() {
        this.setState({
            messageConfig: {
                target: DLG_TARGETS.PaperCheckNoticeInfoDialog,
                config: {
                    onClose: this.onCloseDialog
                }
            }
        })
    }

    showPaperCheckMessageDialog(message: any = {}) {
        let { onCloseCustom, onOkCustom } = message;
        this.setState({
            messageConfig: {
                target: DLG_TARGETS.PaperCheckMessageDialog,
                config: {
                    message: {
                        ...message
                    },
                    onClose: (isCloseIcon = false) => {
                        this.onCloseDialog();
                        onCloseCustom && onCloseCustom(isCloseIcon);
                    },
                    onOk: () => {
                        this.onCloseDialog();
                        onOkCustom && onOkCustom();
                    },
                }
            }
        })
    }

    showPaperCheckResultNoticeMessage(message: any = {}) {
        this.setState({
            messageConfig: {
                target: DLG_TARGETS.PaperCheckResultNoticeMessage,
                config: {
                    onClose: this.onCloseDialog,
                    ...message
                }
            }
        })
    }

    onClosePaperCheckDialog() {
        store.paperCheckStore.updateIsShowPaperCheckDialog(false);
    }
    onClosePaperCheckHistoryDialog() {
        store.paperCheckStore.setShowPaperCheckHistoryDialog(false);
    }

    onClosePaperCheckResultDialog() {
        this.setState({
            resultItem: null
        }, store.paperCheckStore.updateIsShowPaperCheckResultDialog.bind(store.paperCheckStore, false))
    }

    showPaperCheckResultDialog(itemId: StringOrNumber) {
        let resultItem: PaperCheckItemInstance;
        let paperCheckHistoryList = store.paperCheckStore.paperCheckHistoryList as Array<PaperCheckItemInstance>;
        resultItem = paperCheckHistoryList.find(item => item.orderId === itemId || item.checkId === itemId);
        if (typeof resultItem === 'object') {
            this.setState({
                resultItem
            }, store.paperCheckStore.updateIsShowPaperCheckResultDialog.bind(store.paperCheckStore, true))
        }
    }

    showPaperCheckDialog({ checkTypeName = PAPER_CHECK_NEW, isAutoShowFileSelect = false, from = '', ...otherInfo } = {} as CheckDialogShowInfo) {
        if (!store.appStore.checkAppSignIn()) {
            return;
        }
        if (from) {
            this.sendJaegerData(from);
        }
        let checkType = otherInfo.checkType || CHECK_TYPE.New;
        if (checkTypeName && checkTypeName.indexOf(CHECK_TYPE.Published) > -1) {
            checkType = CHECK_TYPE.Published;
        }
        this.setState({
            checkDialogShowInfo: {
                ...this.state.checkDialogShowInfo,
                ...otherInfo,
                checkType,
                isAutoShowFileSelect
            }
        }, store.paperCheckStore.updateIsShowPaperCheckDialog.bind(store.paperCheckStore, true))
    }

    sendJaegerData(from: string) {
        let jaegerData: any;
        switch (from) {
            case 'discover':
                jaegerData = { ...PCHECKER_JAEGERDATA_MAP.PChecker_dis_click };
                break;
            case 'home':
                jaegerData = { ...PCHECKER_JAEGERDATA_MAP.PChecker_home_click };
                break;
            case 'paper-check':
                jaegerData = { ...PCHECKER_JAEGERDATA_MAP.PChecker_tab_PTS_click };
                break;
            default:
                break;
        }
        // if (jaegerData) {
        //     store.paperCheckStore.sendJaegerData(jaegerData)
        // }
    }

    onClosePaperCheckDiscountNotice() {
        let storageKey = getDiscountNoticeDisplayedStorageKey(this.state.discountDetail);
        storageSetItem(localStorage, storageKey, true);
        this.setState({
            isShowPaperCheckDiscountNotice: false
        })
    }
    onUsePaperCheck() {
        this.onClosePaperCheckDiscountNotice();
        this.showPaperCheckDialog({ from: 'discover' });
    }

    render(): ReactNode {
        let { isShowPaperCheckHistoryDialog, isShowPaperCheckDialog, isShowPaperCheckResultDialog, paperCheckHistoryList } = store.paperCheckStore;
        let { messageConfig, checkDialogShowInfo, resultItem, discountDetail, isShowPaperCheckDiscountNotice } = this.state;
        return (
            <>
                {
                    isShowPaperCheckDialog && wrapDialog(
                        <PaperCheckDialog
                            containerCallbacks={this}
                            visible={isShowPaperCheckDialog}
                            {...checkDialogShowInfo}
                            onClose={this.onClosePaperCheckDialog}
                        />
                    )
                }
                {
                    isShowPaperCheckHistoryDialog && wrapDialog(
                        <PaperCheckHistoryDialog
                            visible={isShowPaperCheckHistoryDialog}
                            paperCheckHistoryList={paperCheckHistoryList}
                            onClose={this.onClosePaperCheckHistoryDialog}
                        />
                    )
                }
                {
                    (isShowPaperCheckResultDialog && resultItem) && wrapDialog(
                        <PaperCheckResultDialog
                            visible={isShowPaperCheckResultDialog}
                            resultItem={resultItem}
                            onClose={this.onClosePaperCheckResultDialog}
                        />
                    )
                }
                <DialogContainer {...(messageConfig || {})} />
                {
                    isShowPaperCheckDiscountNotice && wrapDialog(
                        <PaperCheckDiscountNotice 
                            discount={discountDetail}
                            onClose={this.onClosePaperCheckDiscountNotice}
                            onUsePaperCheck={this.onUsePaperCheck}
                        />
                    )
                }
            </>
        )
    }
}

export default PaperCheckContainer
